export default "__VITE_ASSET__BwjODonc__"